






















































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import { BookApi } from "@/api/bookApi";
import { getImagePath, isLogin } from "@/utils/utils";
import { message } from "ant-design-vue";
import "jquery";
declare let BookReader: any;
declare let $: any;

@Component({
  components: {
    Header,
    Footer,
  },
})
export default class BookDetail extends Vue {
  bookApi = new BookApi();
  isShowSlider = 0;
  isComment = 0;
  bookJson: Array<any> = [];
  refNews: Array<any> = [];
  refImageText: Array<any> = [];
  refDic: Array<any> = [];
  refVideo: Array<any> = [];
  refBook: Array<any> = [];
  comments: Array<any> = [];
  id = 0;
  commentContent = "";
  br: any = {};
  currentIndex = null;
  currentIds: Array<number> = [];

  mounted() {
    this.id = Number(this.$route.query["id"]);
    this.instantiateBookReader();
    // this.getExtInfo();

    $(document).on("contextmenu", "img.BRpageimage", function() {
      return false;
    });
  }

  beforeDestroy() {
    $(document).off("contextmenu", "img.BRpageimage");
  }

  @Watch("br", { immediate: false, deep: true })
  getFirstIndex(newVal: any, oldVal: any) {
    if (
      this.currentIndex != newVal.firstIndex &&
      this.bookJson &&
      this.bookJson.length > 0
    ) {
      this.currentIds = [];
      let ids = "";
      if (newVal.firstIndex >= 0) {
        if (ids != "") {
          ids += "," + this.bookJson[newVal.firstIndex]["ID"];
        } else {
          ids = this.bookJson[newVal.firstIndex]["ID"];
        }
        this.currentIds.push(this.bookJson[newVal.firstIndex]["ID"]);
      }
      if (ids != "") {
        ids += "," + this.bookJson[newVal.firstIndex + 1]["ID"];
      } else {
        ids = this.bookJson[newVal.firstIndex + 1]["ID"];
      }
      this.currentIds.push(this.bookJson[newVal.firstIndex + 1]["ID"]);
      this.getExtInfo(ids);
      this.currentIndex = newVal.firstIndex;
    }
  }

  showRightSlider() {
    this.isShowSlider = 1;
    this.isComment = 0;
  }

  hideRightSlider() {
    this.isShowSlider = 0;
  }

  showComment() {
    this.isShowSlider = 1;
    this.isComment = 1;
  }

  getExtInfo(ids: string) {
    this.bookApi.getExtInfo(ids).then((res) => {
      this.refNews = res.data.refNews;
      this.refImageText = res.data.refImageText;
      this.refDic = res.data.refDic;
      this.refVideo = res.data.refVideo;
      this.refBook = res.data.refBook;
    });
  }

  giveLove() {
    message.success("点赞成功");
  }

  comment() {
    if (!isLogin()) {
      message.warning("请先去登录才能发布评论");
    } else {
      this.bookApi.comment(this.id, this.commentContent).then((res) => {
        message.success("评论成功");
        const item: any = {};
        item.Comment = res.data.Comment;
        item.CreateTime = res.data.CreateTime;
        item.CustomerAva = sessionStorage.getItem("avaUrl");
        item.ID = res.data.ID;
        item.NickName = sessionStorage.getItem("nickName");
        this.comments.splice(0, 0, item);
        this.commentContent = "";
      });
    }
  }

  instantiateBookReader() {
    // const _this = this;
    this.bookApi.getBookDetail(this.id).then((res) => {
      this.comments = res.data.comments;
      const bookJson = (this.bookJson = res.data.detailList);
      const options = {
        isBeta: false,
        el: "#BookReader",
        enableMobileNav: false,
        urlMode: "history",
        urlTrackedParams: ["page", "search", "mode"],
        enableBookTitleLink: false,
        bookUrlText: null,
        startFullscreen: false,
        initialSearchTerm: null,
        onePage: { autofit: "auto" },
        showToolbar: false,
        autoResize: true,
        useSrcSet: false,
        enableMultipleBooks: false,
        ui: "full",
        pageProgression: "lr",
        // Total number of leafs
        getNumLeafs: function() {
          return bookJson.length;
        },
        getPageWidth: function(index: number) {
          return 700;
        },
        getPageHeight: function(index: number) {
          return 850;
        },

        // We load the images from archive.org -- you can modify this function to retrieve images
        // using a different URL structure
        getPageURI: function(index: number, reduce: any, rotate: any) {
          // reduce and rotate are ignored in this simple implementation, but we
          // could e.g. look at reduce and load images from a different directory
          // or pass the information to an image server
          return getImagePath(bookJson[index]["PageUrl"]);
        },

        // Return which side, left or right, that a given page should be displayed on
        // getPageSide: function(index: number) {
        //   if (0 == (index & 0x1)) {
        //     return "R";
        //   } else {
        //     return "L";
        //   }
        // },

        // This function returns the left and right indices for the user-visible
        // spread that contains the given index.  The return values may be
        // null if there is no facing page or the index is invalid.
        // getSpreadIndices: function(pindex: number) {
        //   const spreadIndices: Array<any> = [null, null];
        //   if ("rl" == this.pageProgression) {
        //     // Right to Left
        //     if (this.getPageSide(pindex) == "R") {
        //       spreadIndices[1] = pindex;
        //       spreadIndices[0] = pindex + 1;
        //     } else {
        //       // Given index was LHS
        //       spreadIndices[0] = pindex;
        //       spreadIndices[1] = pindex - 1;
        //     }
        //   } else {
        //     // Left to right
        //     if (this.getPageSide(pindex) == "L") {
        //       spreadIndices[0] = pindex;
        //       spreadIndices[1] = pindex + 1;
        //     } else {
        //       // Given index was RHS
        //       spreadIndices[1] = pindex;
        //       spreadIndices[0] = pindex - 1;
        //     }
        //   }
        //   // console.log("getSpreadIndices:" + pindex);
        //   return spreadIndices;
        // },

        // For a given "accessible page index" return the page number in the book.
        //
        // For example, index 5 might correspond to "Page 1" if there is front matter such
        // as a title page and table of contents.
        // getPageNum: function(index: number) {
        //   // console.log("getPageNum:" + index);
        //   return index + 1;
        // },
      };
      this.br = new BookReader(options);
      this.br.init();
    });
  }
}
